<p-dialog
  [visible]="unblockClientBookingModal()"
  [modal]="true"
  [style]="{ width: '30vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  (onHide)="closeDialogEvent()"
  aria-label="unblock-client-booking-dialog"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center gap-2">
      <i class="fa fa-check-circle text-xl text-primary" aria-hidden="true"></i>
      <span class="font-semibold text-lg">
        {{ 'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.TITLE' | translate }}
      </span>
    </div>
  </ng-template>

  <div class="p-3">
    <!-- Client Info -->
    <div
      class="flex align-items-center gap-3 mb-4 p-3 surface-100 border-round"
    >
      <p-avatar
        [label]="allClientData?.full_name | shortName"
        [image]="allClientData?.image"
        shape="circle"
        size="large"
        styleClass="text-lg"
        aria-label="client-avatar"
      />
      <div>
        <div class="font-semibold text-900">{{ allClientData?.full_name }}</div>
        <div class="text-sm text-600">{{ allClientData?.email_id }}</div>
      </div>
    </div>

    <!-- Confirmation Message -->
    <div class="mb-4">
      <p class="text-700 text-base m-0">
        {{
          'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.CONFIRMATION_MESSAGE'
            | translate
        }}
      </p>
    </div>

    <!-- Warning Message -->
    <div class="p-3 surface-100 border-round border-left-3 border-primary">
      <div class="flex align-items-start gap-2">
        <i class="fa fa-info-circle text-primary mt-1" aria-hidden="true"></i>
        <div class="text-sm text-700">
          {{ 'CLIENT_PROFILE.UNBLOCK_CLIENT_BOOKING.INFO_MESSAGE' | translate }}
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        pRipple
        type="button"
        [label]="'CLIENT_PROFILE.NO' | translate"
        class="p-button-outlined p-button-secondary"
        (click)="closeDialogEvent()"
        [disabled]="btnLoading"
        aria-label="cancel-button"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        [label]="'CLIENT_PROFILE.YES' | translate"
        class="p-button-success"
        (click)="unblockClientBooking()"
        [loading]="btnLoading"
        aria-label="unblock-booking-button"
      ></button>
    </div>
  </ng-template>
</p-dialog>
